<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                    @click="showAddDialog()"
                    prepend-icon="mdi-plus"
                    class="mt-1 rounded-lg"
                    color="routesColor"
                    height="40px"
                    elevation="2">
                    Add Mentoring
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.mentoring_date="{ item }">
                                <span>{{ formatDate(item.mentoring_date) }} </span>
                            </template>
                            <template v-slot:item.closeout_date="{ item }">
                                <span>{{ formatDate(item.closeout_date) }} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn @click="showViewDialog(item)" size="small" variant="outlined" text="View Details" color="green" elevation="3"></v-btn>
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="confirmDelete" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want remove this mentoring?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteMentoring()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <FacultyMentoringCommitmentDialog ref="FacultyMentoringCommitmentDialog" @refresh="init()" />
    <MentoringDialog ref="MentoringDialog" @refresh="init()" />
</template>

<script>
import { defineComponent } from 'vue';
import FacultyMentoringCommitmentDialog from '../Dialogs/FacultyMentoring&CommitmentDialog.vue';
import MentoringDialog from '../Dialogs/MentoringDialog.vue';

export default defineComponent({
    components: {
        FacultyMentoringCommitmentDialog,
        MentoringDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                // { title: 'First Name', align: 'start', sortable: true, key: 'faculty.fname' },
                // { title: 'Last Name', align: 'start', sortable: true, key: 'faculty.lname' },
                { title: 'Mentoring Date', align: 'start', sortable: true, key: 'mentoring_date' },
                { title: 'Close-out Date', align: 'start', sortable: true, key: 'closeout_date' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            confirmDelete: false,
            itemToDelete: null,
            loadingConfirmation: false,
            itemToActivate: null,
            itemToDelete: null,
        }
    },
    methods: {
        async init(){
            this.loading = true
            let res = await this.axiosCall('/mentoring/findAllByInstituteAndSemester/' + this.$store.state.user.office.id + '/' + this.$store.state.semester_schoolyear.id, 'get', null, true)
            if(res.data){
                this.data = res.data
                this.loading = false
            }
        },
        showAddDialog(){
            this.$refs.MentoringDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.MentoringDialog.initUpdate(data)
        },
        showViewDialog(data){
            this.$refs.FacultyMentoringCommitmentDialog.initView(data)
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>